module.exports = __webpack_public_path__ + "static/media/relaxer.6fd87bdf.png";